module.exports = __webpack_public_path__ + "static/img/1.61cf183.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/picGrop1/1.jpg
// module id = Kpeg
// module chunks = 0